<template>
  <a class="block w-full text-right pt-4" href="#">
    {{ $t('navigation.back_to_top') }}
  </a>
</template>
